module.exports = __webpack_public_path__ + "img/telegram.2a03249b.svg";